// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__216c9","header":"PatientQuestionnaire_header__2-z6U","info":"PatientQuestionnaire_info__2L6j_"};